import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, CardBody, Input, Button, Table, FormGroup, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string';
import moment from "moment";
import { toast } from 'react-toastify';
import { isEmpty } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { baseUrl } from '../../constants/environment';
import IconSearch from '../../assets/images/icon-search.png';
import IconEdit from '../../assets/images/icon-edit.png';
import IconActive from '../../assets/images/icon-active.png';
import IconReject from '../../assets/images/icon-reject.png';
import IconImport from '../../assets/images/icon-import.png';
import IconCalendarBlack from '../../assets/images/icon/ic_calendar-black.svg';
import PriceUtils from '../../helpers/PriceUtils';

const configPage = {
    titlePage: 'Danh sách phiếu trả hàng',
    pathPage: '/stockreturn',
    column: 7,
}

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {
        page: 1,
        limit: 25,
        // name:"",
        // sex:"",
    }
}

export const StatusList:any = [
    {
        value: "",
        label: "-Trạng thái-"
    },
    {
        value: 0,
        label: "Mới"
    },
    {
        value: 1,
        label: "Đã duyệt"
    },
    {
        value: 2,
        label: "Xuất trả"
    },
    {
        value: -1,
        label: "Hủy"
    },
]

const List: React.FC<Props> = (props: Props) => {
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState({});
    const [ids, setIds] = useState([]);
    const [branch, setBranch] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const [users, setUsers] = useState([]);
    const searchPrams = queryString.parse(props.location.search)

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
        loadInit()
    }, []);

    useEffect(() => {
        loadData()
        setFilterParams({
            page:page,
            limit: limit,
            ...filter,
        });
    }, [filter]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const getFilterParams = () => {
        const newFilter: any = {}
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case 'page':
                        setPage(Number(searchPrams[key]))
                        break;
                    case 'limit':
                        setLimit(Number(searchPrams[key]))
                        break;
                    default:
                        newFilter[key] = searchPrams[key]
                        break;
                }
            });
            setFilter(newFilter)
        }
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseCategory,
            responseSuppliery,
            responseUsers,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/branch`, params),
            APIClient.GET(`${baseUrl}/supplier`, params),
            APIClient.GET(`${baseUrl}/user`, params),
        ]);
        if (responseCategory.response?.data !== undefined) {
            let ListArr:any = [{
                value: "",
                label: "-Cơ sở-",
            }];
            responseCategory.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setBranch(ListArr)
        }
        if (responseSuppliery.response?.data !== undefined) {
            let ListArr:any = [{
                value: "",
                label: "-Nhà cung cấp-",
            }];
            responseSuppliery.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setSupplier(ListArr)
        }
        if (responseUsers.response?.data !== undefined) {
            let ListArr:any = [{
                value: "",
                label: "-Nhân viên tạo-",
            }];
            responseUsers.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setUsers(ListArr)
        }
    }

    const loadData = async () => {
        setLoading(true);
        const formData = {
            page: filter?.page,
            limit: filter?.page,
            ...filter,
        }
        if(formData?.name === "") {
            delete formData?.name
        }
        if(formData?.status === "") {
            delete formData?.status
        }
        if(formData?.from && formData?.to) {
            formData.from = moment(formData?.from).startOf('day').valueOf()
            formData.to = moment(formData?.to).endOf('day').valueOf()
        }
        const url = `${baseUrl}/stock/return`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response.response?.data)
            setTotalElements(response.response?.total)
        }
    }

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    filter={filter}
                    configPage={configPage}
                    branch={branch}
                    supplier={supplier}
                    users={users}
                    setFilter={(filter: any) => setFilter(filter)}
                />
                <DataTableList
                    user={props?.user}
                    data={data} loading={loading}
                    page={page} limit={limit}
                    configPage={configPage}
                    history={props.history}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                {
                    data?.length > 0 &&
                    <Pagination
                        link={configPage.pathPage + '/list'}
                        setPage={(page: number) => setFilter({...filter, page:page})}
                        page={filter?.page}
                        limit={filter?.limit}
                        setLimit={(limit: number) => setFilter({...filter, limit:limit})}
                        type={'noresetpage'}
                        totalElements={totalElements}
                    />
                }
                
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                <RenderActionModal closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
            </ModalPopup>
        </React.Fragment>
    );
};

const DataTableList = (props: any) => {
    const { data, filter, loading, limit, page, is_draft, configPage, handleActionModal} = props
    const start = limit * (page - 1)
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th style={{ minWidth: 120 }}>Mã đơn nhập</th>
                    <th style={{ minWidth: 120 }}>Mã đơn trả</th>
                    <th style={{ minWidth: 120 }}>Nhà cung cấp</th>
                    <th style={{ minWidth: 120 }}>Cơ sở trả</th>
                    <th style={{ minWidth: 120 }}>Số lượng trả</th>
                    <th style={{ minWidth: 120 }}>Giá trị trả</th>
                    <th style={{ minWidth: 120 }}>Nhân viên</th>
                    <th style={{ minWidth: 120 }}>Thời gian</th>
                    <th style={{ minWidth: 120 }}>Trạng thái</th>
                    <th style={{ minWidth: 120, width: 170 }} >Hành động</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Chưa có phiếu trả hàng nào!" />;
        }
        const gotoDetail = (item:any) => {
            router?.push(`/stockreturn/${item?.id}/view`)
        }

        return (
            <tbody>
                {data && data.map((item: any, index: number) => {
                    const total_product = item?.stock_return_products?.reduce((prev:any, item:any)=>{
                        prev += Number(item?.quantity | 0)
                        return prev
                    },0)
                    return (
                        <tr key={index}>
                            <td onClick={() => gotoDetail(item)}>{item?.stock_import_ids?.map((u:any) => u.code).join(', ') || item?.stock_import_id?.code}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.code}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.supplier_id?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.branch_id?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{PriceUtils.format(total_product || 0, '')}</td>
                            <td onClick={() => gotoDetail(item)}>{PriceUtils.format(item?.sub_total || 0)}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.created_uid?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{moment(item?.created_time).format('DD/MM/YYYY')}</td>
                            <td onClick={() => gotoDetail(item)}>
                                {item?.status == 0 && <span className={'text-dark'}>Mới</span>}
                                {item?.status == 1 && <span className={'text-success'}>Đã duyệt</span>}
                                {item?.status == 2 && <span className={'text-primary'}>Xuất trả</span>}
                                {item?.status == -1 && <span className={'text-danger'}>Hủy</span>}
                            </td>
                            <td className='text-right'>
                                <div className="table-action">
                                    {item?.status === 0 && 
                                        <>
                                            <div className="button-nutri" onClick={() => router?.push(`/stockreturn/${item?.id}`)}>
                                                <img width={20} height={20} src={IconEdit} alt="edit" />
                                            </div>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'active', data: item})}>
                                                <img width={20} height={10} src={IconActive} alt="edit" />    
                                            </div>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'return', data: item})}>
                                                <img width={20} height={20} src={IconImport} alt="edit" />    
                                            </div>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'reject', data: item})}>
                                                <img width={20} height={20} src={IconReject} alt="edit" />    
                                            </div>
                                            
                                        </>
                                    }
                                    {item?.status === 1 && 
                                        <>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'return', data: item})}>
                                                <img width={20} height={20} src={IconImport} alt="edit" />    
                                            </div>
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'reject', data: item})}>
                                                <img width={20} height={20} src={IconReject} alt="edit" />    
                                            </div>
                                            
                                        </>
                                    }
                                </div>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        )
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
        </div>
    );
};

const DataFilter = (props: any) => {
    const { setFilter, filter, setPage, branch, supplier, users} = props
    const [name, setName] = useState(filter?.name);
    const timer = useRef<any>(null);

    const handleChangeFilterDate = (date:any) => {
        if(date.length === 2){
            const from = moment(date[0]).startOf("day").format('YYYY-MM-DD')
            const to = moment(date[1]).endOf("day").format('YYYY-MM-DD')
            setFilter({
                ...filter,
                from:from,
                to:to
            })
        }else if(date.length === 0){
            setFilter({
                ...filter,
                from:undefined,
                to:undefined
            })
        }   
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            clearTimeout(timer.current)
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value,
            })
        }
    }

    const handleChange = (e: any) => {
        clearTimeout(timer.current)
        const { name, value } = e?.target
        if(name == 'provinces_code') {
            setFilter({
                ...filter,
                page: 1,
                district_code: '',
                wards_code: '',
                [name]: value
            })
        }
        else if(name == 'district_code') {
            setFilter({
                ...filter,
                page: 1,
                wards_code: '',
                [name]: value
            })
        }
        else {
            setFilter({
                ...filter,
                page: 1,
                [name]: value
            })
        }
    }

    return (
        <Row className="mb-3 filter-custom">
            <Col xl={10}>
                <Row>
                    <Col xl={3}>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                <img src={IconSearch} width={18} height={18} alt=""/>
                            </InputGroupAddon>
                            <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Tìm kiếm theo mã phiếu trả/ mã phiếu nhập" />
                        </InputGroup>
                    </Col>
                    <Col xl={9}>
                        <Row>
                            <Col xl={4}>
                                <InputGroup className='form-control picker-custom'>
                                    <Flatpickr 
                                        value={[new Date(moment(filter?.from,'YYYY-MM-DD').startOf('day').valueOf()), new Date(moment(filter?.to,'YYYY-MM-DD').startOf('day').valueOf())]}
                                        onChange={(date:any) => { handleChangeFilterDate(date) }} 
                                        options={{
                                            mode: "range",
                                            locale: Vietnamese,
                                            dateFormat: "d/m/Y",
                                        }}
                                        className="flatpickr-input active"
                                        placeholder="Ngày tạo"
                                    />
                                    <div className="icon-clear" style={{right:23}} onClick={()=>{setFilter({...filter, from: null, to:null})}}>
                                        <i className="uil-times mr-1"></i>
                                    </div>
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Nhân viên tạo-"
                                    options={users}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'created_uid', value: value.value } })
                                    }}
                                    value={users?.filter((option: any) => filter?.created_uid === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Nhà cung cấp-"
                                    options={supplier}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'supplier_id', value: value.value } })
                                    }}
                                    value={supplier?.filter((option: any) => filter?.supplier_id === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Cơ sở-"
                                    options={branch}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'branch_id', value: value.value } })
                                    }}
                                    value={branch?.filter((option: any) => filter?.branch_id === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng Thái-"
                                    options={StatusList}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'status', value: value.value } })
                                    }}
                                    value={StatusList?.filter((option: any) => filter?.status === option.value)}
                                ></Select>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xl={2}>
                <div className="text-right">
                    <Link to={`${configPage.pathPage}/add`}><Button color="success" className="ml-2"><i className='uil uil-plus mr-1'></i>Thêm mới</Button></Link>
                </div>
            </Col>
        </Row>
    );
};

export const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData } = props

    const handleActive = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/return/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 1
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xác nhận trả hàng thành công!')
            closeModal()
            loadData()
        }
    }

    const handleReject = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/return/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: -1
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Hủy phiếu trả hàng thành công!')
            closeModal()
            loadData()
        }
    }

    const handleImport = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/return/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 2
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xuất trả thành công!')
            closeModal()
            loadData()
        }
    }

    const handleDelete = async() => {
        setLoading(true)
        const url = `${baseUrl}/stock/return/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa phiếu thành công!')
            closeModal()
            loadData()
        }
    }

    const handleConfirm = async() => {
        action?.onSubmit()
        closeModal()
    }

    return (
        <CardBody className='p-0' style={{width:400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {(action?.type === 'active' || action?.type === 'activeConfirm') && "Xác nhận phiếu"}
                    {action?.type === 'reject' && "Hủy phiếu"}
                    {(action?.type === 'return' || action?.type === 'returnConfirm') && "Xuất trả"}
                    {action?.type === 'delete' && "Xóa phiếu"}
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {(action?.type === 'active' || action?.type === 'activeConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn xác nhận Phiếu nhập kho này? Phiếu nhập kho ở trạng thái Xác nhận sẽ không thể chỉnh sửa thông tin</p>
                        }
                        {action?.type === 'reject' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn Hủy phiếu phiếu trả hàng này?</p>
                        }
                        {(action?.type === 'return' || action?.type === 'returnConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn chuyển trạng thái Xuất trả cho phiếu này? Phiếu ở trạng thái Xuất trả sẽ không thể chỉnh sửa thông tin. Tồn của các sản phẩm sẽ được điều chỉnh tương ứng với số lượng đã nhập</p>
                        }
                         {action?.type === 'delete' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn xóa phiếu này này?<br/> Hành động này không thể hoàn tác</p>
                        }
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                {/* <Button
                    onClick={closeModal}
                    className="ml-2 success-bland" color="success" type="button"
                > Hủy bỏ</Button> */}
                <Button
                    onClick={()=>{
                        action?.type === 'active' && handleActive()
                        action?.type === 'activeConfirm' && handleConfirm()
                        action?.type === 'reject' && handleReject()
                        action?.type === 'return' && handleImport()
                        action?.type === 'returnConfirm' && handleConfirm()
                        action?.type === 'delete' && handleDelete()
                        
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)